import React from 'react';

import Utils from '../Utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import styles from './Icon.module.css';

function Icon({ type, content }) {
    if (type === 'Image') {
        return <img src={`data:image/png;base64,${content}`} alt="Thumbnail" className={styles.icon} />;
    }

    if (type === 'Text') {
        let url = Utils.getUrl(content);
        if (url) {
            if (url.includes('youtu.be')) {
                url = url.replace('youtu.be', 'youtube.com');
            }
            return <img src={`https://www.google.com/s2/favicons?domain=${url}`} alt="Favicon" className={styles.icon} />;
        }
        return <FontAwesomeIcon icon={faFileAlt} className={styles.icon} />;
    }

    return null;
}

export default Icon;
